import { Component } from '@theme/component';

class VelmereDevelopmentPreview extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#render();
  }

  #render() {
    if (!Shopify.designMode && Shopify.theme?.role !== 'development') return;
    const template = this.querySelector('template');
    if (!template) return;
    this.replaceChildren(template.content.cloneNode(true));
    this.hidden = false;
  }
}

if (!customElements.get('velmere-development-preview')) {
  customElements.define('velmere-development-preview', VelmereDevelopmentPreview);
}
